import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import MasterTabs from "../AllTabs/MasterTabs";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
const initialFieldValues = {
  promoCodeId: "00000000-0000-0000-0000-000000000000",
  companyId: "00000000-0000-0000-0000-000000000000",
  code: "",
  amount: "",
  description: "",
  status: "true",
  type: "FLIGHT",
  startDate: "",
  endDate: "",
  createdDate: null
};
const PROMO_CODE_TYPES = [
  { value: "BUS", label: "Bus" },
  { value: "CAR", label: "Car" },
  { value: "FLIGHT", label: "Flight" },
  { value: "HOTEL", label: "Hotel" },
  { value: "VISA", label: "Visa" },
  { value: "SIGHTSEEING", label: "Sightseeing" },
  { value: "PACKAGE", label: "Package" },
  { value: "INSURANCE", label: "Insurance" },
  { value: "TRANSFER", label: "Transfer" },
  { value: "CRUISE", label: "Cruise" },
  { value: "TRAIN", label: "Train" },
  { value: "GENERAL", label: "General" },
];
const PromoCode = () => {
  const { user, loading } = useAuth();
  const [listLoading, setListLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [filters, setFilters] = useState({
    type: "",
    startDate: "",
    endDate: ""
  });
  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
    setValues(initialFieldValues);
  };
  const handleAddShow = () => {
    setRecordForEdit(null);
    setValues({
      ...initialFieldValues,
      status: "true",
      type: "FLIGHT"
    });
    setAddShow(true);
  };
  useEffect(() => {
   if (recordForEdit !== null) {
    const editData = { ...recordForEdit };
    if (editData.startDate) {editData.startDate = editData.startDate.split("T")[0];}
    if (editData.endDate) {editData.endDate = editData.endDate.split("T")[0];}
    editData.status = editData.status ? "true" : "false";
    setValues(editData);
   }
  }, [recordForEdit]);
  const GetData = async (pageNumber) => {
  setListLoading(true);

  try {
    const params = new URLSearchParams();

    if (filters.type) params.append("type", filters.type);
    if (filters.startDate) params.append("startDate", filters.startDate);
    if (filters.endDate) params.append("endDate", filters.endDate);

    const queryString = params.toString();

    const url = `${config.GETPROMOCODEBYCOMPANY}/${user?.cid}?${queryString}`;

    const res = await apiService.getAll(url);

    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  } catch (error) {
    console.log(error);
  } finally {
    setListLoading(false);
  }
};
  const GetLastPageData = () => {
    GetData(totalPages);
  };
  const GetFirstPageData = () => {
    GetData("1");
  };
  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };
  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPROMOCODE, itemToDelete);
      
        await GetData(pageNumber);
      } catch (error) {
       
      }
      handleCloseDeleteModal();
    }
  };
  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  const validateForm = () => {

    let temp = {};

    if (!values.code.trim())
        temp.code = "Promo code is required.";

    if (!values.amount)
        temp.amount = "Amount is required.";
    else if (Number(values.amount) <= 0)
        temp.amount = "Amount must be greater than 0.";

    if (!values.startDate)
        temp.startDate = "Start Date is required.";

    if (!values.endDate)
        temp.endDate = "End Date is required.";

    if (
        values.startDate &&
        values.endDate &&
        new Date(values.endDate) < new Date(values.startDate)
    ) {
        temp.endDate = "End Date cannot be before Start Date.";
    }

    setErrors(temp);

    return Object.keys(temp).length === 0;
};
 const handleSubmit = async (e) => {
    e.preventDefault();
     if (!validateForm()) return;
    setBtnLoading(true);
    try {
        const codeValue = values.code ? values.code.toUpperCase().trim() : "";
        const amountValue = values.amount ? parseInt(values.amount) : 0;
        const formData = new FormData();
        formData.append("promoCodeId",values.promoCodeId || "00000000-0000-0000-0000-000000000000");
        formData.append("code", codeValue);
        formData.append("amount", amountValue);
        formData.append("description", values.description || "");
        formData.append("status", values.status);
        formData.append("type", values.type || "FLIGHT");
        formData.append("companyId", user?.cid);
        if (values.startDate) {formData.append("startDate", values.startDate);}
        if (values.endDate) {formData.append("endDate", values.endDate);}
        const isNew =values.promoCodeId ==="00000000-0000-0000-0000-000000000000";
        if (isNew) {await apiService.create(config.CREATEPROMOCODE, formData);
        } else {
            await apiService.update(config.UPDATEPROMOCODE, formData);
        }
        await GetData(pageNumber);
        resetForm();
    } catch (error) {
    } finally {
        setBtnLoading(false);
    }
};
 const handleInputChange = (e) => {

    const { name, value } = e.target;

    setValues({
        ...values,
        [name]: value
    });

    setErrors(prev => ({
        ...prev,
        [name]: ""
    }));
};
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setPageNumber(1);
    GetData(1);
  };
  const handleClearFilters = () => {
    setFilters({
      type: "",
      startDate: "",
      endDate: ""
    });
    setPageNumber(1);
    setTimeout(() => {
      GetData(1);
    }, 100);
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
    setAddShow(false);
    setBtnLoading(false);
    setRecordForEdit(null);
  };
  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const [year, month, day] = dateString.split("T")[0].split("-");
  const months = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
  ];

  return `${day}-${months[parseInt(month, 10) - 1]}-${year}`;
};
  const getTypeBadgeColor = (type) => {
    const colors = {
      'BUS': 'bg-success',
      'CAR': 'bg-info',
      'FLIGHT': 'bg-primary',
      'HOTEL': 'bg-warning',
      'VISA': 'bg-danger',
      'SIGHTSEEING': 'bg-purple',
      'PACKAGE': 'bg-dark',
      'INSURANCE': 'bg-secondary',
      'TRANSFER': 'bg-cyan',
      'CRUISE': 'bg-pink',
      'TRAIN': 'bg-orange',
      'GENERAL': 'bg-light text-dark'
    };
    return colors[type] || 'bg-secondary';
  };
  const getStatusDisplay = (status) => {
    if (status === true || status === "true") {
      return { text: "Active", className: "bg-success" };
    }
    return { text: "Inactive", className: "bg-danger" };
  };
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <MasterTabs pageName="PROMOCODE" />
                </div>
                <div className="card-body border-bottom">
                  <form onSubmit={handleFilterSubmit}>
                    <div className="row g-3 align-items-end">
                      <div className="col-sm-3">
                        <label htmlFor="type" className="form-label">Type</label>
                        <select
                          id="type"
                          name="type"
                          className="form-select"
                          value={filters.type}
                          onChange={handleFilterChange}
                        >
                          <option value="">All Types</option>
                          {PROMO_CODE_TYPES.map(type => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-sm-2">
                        <label htmlFor="startDate" className="form-label">Start Date</label>
                        <input
                          type="date"
                          id="startDate"
                          name="startDate"
                          className="form-control"
                          value={filters.startDate}
                          onChange={handleFilterChange}
                        />
                      </div>
                      <div className="col-sm-2">
                        <label htmlFor="endDate" className="form-label">End Date</label>
                        <input
                          type="date"
                          id="endDate"
                          name="endDate"
                          className="form-control"
                          value={filters.endDate}
                          onChange={handleFilterChange}
                        />
                      </div>
                      <div className="col-sm-auto">
                        <button type="submit" className="btn btn-primary">
                          Search
                        </button>
                      </div>
                      <div className="col-sm-auto">
                        <button 
                          type="button" 
                          className="btn btn-danger"
                          onClick={handleClearFilters}
                        >
                           Clear
                        </button>
                      </div>
                      <div className="col-sm-auto ms-auto">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add Promo Code
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="promoCodeTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>S.No</th>
                          <th>Code</th>
                          <th>Amount</th>
                          <th>Type</th>
                          <th>Status</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                           <th>Description</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {listLoading ? (
                          <tr>
                              <td colSpan="9" className="text-center py-5">
                               <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                               </div>
                              </td>
                          </tr>
                         ) :lists.length > 0 ?(
                          lists.map((v, index) => {
                            const statusInfo = getStatusDisplay(v.status);
                            return (
                              <tr key={v.promoCodeId}>
                                <td>{index + 1}</td>
                                <td><span className="fw-semibold">{v.code}</span></td>
                                <td>{v.amount}</td>
                                <td>
                                  <span className={`badge ${getTypeBadgeColor(v.type)}`}>
                                    {v.type}
                                  </span>
                                </td>
                                <td>
                                  <span className={`badge ${statusInfo.className}`}>
                                    {statusInfo.text}
                                  </span>
                                </td>
                                <td>{formatDate(v.startDate)}</td>
                                <td>{formatDate(v.endDate)}</td>
                                 <td>{v.description}</td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Edit"
                                    >
                                      <Link
                                        className="edit-item-btn"
                                        onClick={(e) => showEditDetails(v)}
                                      >
                                        <i className="ri-pencil-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Delete"
                                    >
                                      <Link
                                        className="remove-item-btn"
                                        onClick={(e) =>
                                          handleOpenDeleteModal(v.promoCodeId)
                                        }
                                      >
                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                            <tr>
                              <td colSpan="9" className="text-center">
                                 No Promo Codes Found
                              </td>
                            </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" + (data.previousPage === null ? " disabled" : "")
                        }
                        onClick={() => GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" + (data.nextPage === null ? " disabled" : "")
                        }
                        onClick={() => GetLastPageData()}
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Add/Edit Modal */}
        <Modal show={addShow} onHide={handleAddClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              {values.promoCodeId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Promo Code
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-4 mb-3">
                  <label htmlFor="code" className="form-label">
                    Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={values.code || ""}
                    name="code"
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Enter Promo Code"
                    maxLength={50}
                    onInput={toInputUppercase}
                    required
                  />
                  {errors.code && (<small className="text-danger">{errors.code}</small>)}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="type" className="form-label">
                    Type 
                  </label>
                  <select
                    name="type"
                    value={values.type || "FLIGHT"}
                    onChange={handleInputChange}
                    className="form-select"
                   
                  >
                    {PROMO_CODE_TYPES.map(type => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  
                  </select>
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <select
                    name="status"
                    value={values.status}
                    onChange={handleInputChange}
                    className="form-select"
                   >
                     <option value="true">Active</option>
                     <option value="false">Inactive</option>
                  </select>
                </div>
                <div className="col-lg-6 mb-3">
                  <label htmlFor="amount" className="form-label">
                    Amount <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    value={values.amount || ""}
                    name="amount"
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Enter amount (e.g., 50)"
                    min="0"
                    step="0.01"
                    required
                  />
                  {errors.amount && (<small className="text-danger">{errors.amount}</small>)}
                </div>
                <div className="col-lg-6 mb-3">
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <textarea
                    value={values.description || ""}
                    name="description"
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Enter description"
                    rows="2"
                    maxLength={200}
                  />
                </div>
                <div className="col-lg-6 mb-3">
                  <label htmlFor="startDate" className="form-label">
                    Start Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    value={values.startDate || ""}
                    name="startDate"
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                  {errors.startDate && (<small className="text-danger">{errors.startDate}</small>)}
                </div>
                <div className="col-lg-6 mb-3">
                  <label htmlFor="endDate" className="form-label">
                    End Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    value={values.endDate || ""}
                    name="endDate"
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                  {errors.endDate && (<small className="text-danger">{errors.endDate}</small>)}
                </div>
              </div>
              <Modal.Footer>
                <div className="hstack gap-2 justify-content-end">
                  {btnLoading === false ? (
                    <button type="submit" className="btn btn-primary">
                      {values.promoCodeId === "00000000-0000-0000-0000-000000000000"
                        ? "Submit"
                        : "Update"}
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled
                    >
                      <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Please wait...
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                </div>
              </Modal.Footer>
            </form>
          </Modal.Body>
        </Modal>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default PromoCode;